module.exports = __webpack_public_path__ + "static/media/linkedin-icon.66e77801.svg";